import { CreateSalesDepartmentDto, SalesDepartmentDto, UpdateSalesDepartmentDto, UserDto } from '@sr/dto';
import { FormTools, VALIDATION_GREATER_THAN_ZERO, VALIDATION_PERCENTAGE, VALIDATION_REQUIRED_FIELD } from 'utils/form-tools';
import { FormikErrors } from 'formik';
import { toOptionalNumberField } from '../../utils/form-helper';

export type PopupFormData = {
  title: string;
  employees: UserDto[];
  managerId: number | '';
  plan: number | '';
  planFulfillmentPercentage: number | '';
  planNonFulfillmentPercentage: number | '';
};

export const formTools: FormTools<SalesDepartmentDto, CreateSalesDepartmentDto, UpdateSalesDepartmentDto, PopupFormData> = {
  toUpdateDto: (id, formData) => ({
    id: id,
    title: formData.title,
    employees: formData.employees.map((employee) => employee.id),
    managerId: formData.managerId ? Number(formData.managerId) : undefined,
    plan: toOptionalNumberField(formData.plan),
    planFulfillmentPercentage: toOptionalNumberField(formData.planFulfillmentPercentage),
    planNonFulfillmentPercentage: toOptionalNumberField(formData.planNonFulfillmentPercentage),
  }),
  toCreateDto: (formData) => ({
    title: formData.title,
    employees: formData.employees.map((employee) => employee.id),
    managerId: formData.managerId ? Number(formData.managerId) : undefined,
    plan: toOptionalNumberField(formData.plan),
    planFulfillmentPercentage: toOptionalNumberField(formData.planFulfillmentPercentage),
    planNonFulfillmentPercentage: toOptionalNumberField(formData.planNonFulfillmentPercentage),
  }),
  fromDto: (dto) => ({
    ...dto,
    managerId: dto.managerId ? dto.managerId : '',
  }),
  validate: (values: PopupFormData): FormikErrors<PopupFormData> => {
    let validationResult: FormikErrors<PopupFormData> = {};
    if (!values.title) {
      validationResult.title = VALIDATION_REQUIRED_FIELD;
    }

    if (values.plan && (values.plan <= 0 || isNaN(Number(values.plan)))) {
      validationResult.plan = VALIDATION_GREATER_THAN_ZERO;
    }
    if (values.planFulfillmentPercentage && (values.planFulfillmentPercentage < 0 || values.planFulfillmentPercentage > 100 || isNaN(Number(values.planFulfillmentPercentage)))) {
      validationResult.planFulfillmentPercentage = VALIDATION_PERCENTAGE;
    }
    if (
      values.planNonFulfillmentPercentage &&
      (values.planNonFulfillmentPercentage < 0 || values.planNonFulfillmentPercentage > 100 || isNaN(Number(values.planNonFulfillmentPercentage)))
    ) {
      validationResult.planNonFulfillmentPercentage = VALIDATION_PERCENTAGE;
    }
    return validationResult;
  },
  emptyValues: () => ({
    title: '',
    employees: [],
    managerId: '',
    plan: '',
    planFulfillmentPercentage: '',
    planNonFulfillmentPercentage: '',
  }),
};
